/**
 * Billing permission helpers
 *
 * Utilities for checking if users have access to billing operations.
 */

/**
 * Check if user has permission to access billing features.
 *
 * Users with either organizations:billing (org owner/admin) or system:admin
 * can access billing pages and operations.
 *
 * @param permissions Array of permission strings from user context
 * @returns true if user can access billing, false otherwise
 */
export function canAccessBilling(permissions: string[]): boolean {
  return permissions.includes('organizations:billing') || permissions.includes('system:admin');
}
